import styled from "styled-components";

export const Wrapper = styled.div`
    align-self: left;
    margin-left: -30px;
`;

export const Icon = styled.div`
    justify-content: left;
    align-items: center;
    display: flex;
    flex-direction: row;
`;

export const Temperature = styled.p`
    font-size: 120px;
    font-weight: 200;
    //padding: 15px;
    margin: 0 !important;
`;

export const Description = styled.p`
    font-size: 20px;
    margin: 0 !important;
`;

export const Title = styled.p`
    font-size: 30px;
    margin: 0 !important;
`;

export const Img = styled.img`
    height: 50px;
`;